<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.214"
    height="12"
    viewBox="0 0 9.214 12"
  >
    <path
      d="M14.371,9.82a3.121,3.121,0,0,0,1.414-2.391A3.379,3.379,0,0,0,12.357,4H7V16h6.034a3.251,3.251,0,0,0,1.337-6.18Zm-4.8-3.677h2.571a1.286,1.286,0,0,1,0,2.571H9.571Zm3,7.714h-3V11.286h3a1.286,1.286,0,1,1,0,2.571Z"
      transform="translate(-7 -4)"
    />
  </svg>
</template>

<script>
export default {
  name: 'BoldIcon',
};
</script>
